import { collection, addDoc, serverTimestamp } from "firebase/firestore";


export async function logEvent(db, type, userId, metadata = {})
{
  try
  {
    const payload = {type,userId: userId || null,timestamp: serverTimestamp(),metadata,};
    await addDoc(collection(db, "analytics_events"), payload);
  }
  catch (err)
  {
    console.error("Failed to log analytics event:", type, err);
  }
}
